"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSCE_MARKSHEET_TIMER = exports.OSCE_MATCHMAKING_USERS = exports.OSCE_MATCHMAKING = exports.OSCE_MARKSHEET_ACTION = exports.OSCE_ROLE_CHANGE = exports.OsceGroupInit = exports.OSCE_MATCHMAKING_USERS_KEY = exports.OSCE_MATCHMAKING_KEY = exports.OSCE_MARKSHEET_TIMER_KEY = exports.OSCE_MARKSHEET_ACTION_KEY = exports.OSCE_ROLE_CHANGE_KEY = void 0;
const client_1 = require("@apollo/client");
const models_1 = require("../../models");
const fragments_1 = require("../fragments");
exports.OSCE_ROLE_CHANGE_KEY = 'OSCE_ROLE_CHANGE';
exports.OSCE_MARKSHEET_ACTION_KEY = 'OSCE_MARKSHEET_ACTION';
exports.OSCE_MARKSHEET_TIMER_KEY = 'OSCE_MARKSHEET_TIMER';
exports.OSCE_MATCHMAKING_KEY = 'OSCE_MATCHMAKING';
exports.OSCE_MATCHMAKING_USERS_KEY = 'OSCE_MATCHMAKING_USERS';
const OsceGroupInit = (osceMarksheetId) => [
    {
        id: null,
        createdAt: null,
        deletedAt: null,
        osceMarksheetId,
        userId: null,
        user: null,
        role: models_1.EOsceRoles.CANDIDATE,
    },
    {
        id: null,
        createdAt: null,
        deletedAt: null,
        osceMarksheetId,
        userId: null,
        user: null,
        role: models_1.EOsceRoles.EXAMINER,
    },
    {
        id: null,
        createdAt: null,
        deletedAt: null,
        osceMarksheetId,
        userId: null,
        user: null,
        role: models_1.EOsceRoles.ACTOR,
    },
    {
        id: null,
        createdAt: null,
        deletedAt: null,
        osceMarksheetId,
        userId: null,
        user: null,
        role: models_1.EOsceRoles.OBSERVER,
    },
];
exports.OsceGroupInit = OsceGroupInit;
exports.OSCE_ROLE_CHANGE = (0, client_1.gql) `
  subscription osceRoleChangeSubscription($sessionId: String!) {
    osceRoleChange(sessionId: $sessionId) {
      osceMarksheetId
      sessionId
      members {
        osceMarksheetId
        userId
        user {
          id
          displayName
        }
        role
      }
      users {
        id
        displayName
      }
    }
  }
`;
exports.OSCE_MARKSHEET_ACTION = (0, client_1.gql) `
  ${fragments_1.OSCE_MARKSHEET_MARK_FIELDS}
  subscription OsceMarksheetAction($sessionId: String!) {
    osceMarksheetAction(sessionId: $sessionId) {
      osceMarksheetId
      osceStationId
      state
      completed
      sessionId
      agoraId
      userId
      user {
        id
        displayName
        universityId
      }
      activeUsers {
        id
        displayName
      }
      members {
        osceMarksheetId
        userId
        user {
          id
          displayName
        }
        role
      }
      feedback
      timeTaken
      globalScore
      score
      marks {
        ...OsceMarksheetMarkFields
      }
      startedAt
      endedAt
      action
    }
  }
`;
exports.OSCE_MATCHMAKING = (0, client_1.gql) `
  ${fragments_1.OSCE_MATCHMAKING_ACTION_FIELDS}
  subscription OsceMatchmaking($userId: Int!) {
    osceMatchmaking(userId: $userId) {
      ...OsceMatchmakingActionFields
    }
  }
`;
exports.OSCE_MATCHMAKING_USERS = (0, client_1.gql) `
  subscription OsceMatchmakingUsers {
    osceMatchmakingUsers
  }
`;
exports.OSCE_MARKSHEET_TIMER = (0, client_1.gql) `
  subscription OsceMarksheetTimer($sessionId: String!) {
    osceMarksheetTimer(sessionId: $sessionId) {
      osceMarksheetId
      sessionId
      timeRemaining
      totalStationTime
      stage
      state
    }
  }
`;
